"use strict";

export default [
  "$rootScope",
  "$scope",
  "InvestActivityService",
  "MunicipalityRestService",
  function ($rootScope, $scope, InvestActivityService, MunicipalityRestService) {
    $scope.changeViewType = changeViewType;
    $scope.getStrokeColor = getStrokeColor;
    $scope.openDescription = openDescription;
    $scope.getRowLabels = getRowLabels;
    $scope.viewType = "table";
    $scope.investments = [];
    $scope.investmentsRow = new Map();
    $scope.sum = 0;
    $scope.loading = false;
    $scope.municipalities = [];
    $scope.availableMunicipalities = [];

    init();

    function createMunicipalitiesDisctionary(investments = $scope.investments) {
      const dict = new Map();
      for (const element of investments) {
        const firstLetter = element.name[0].toUpperCase();
        const prevValue = dict.get(firstLetter);
        if (prevValue) {
          dict.set(firstLetter, [...prevValue, element]);
          continue;
        }
        dict.set(firstLetter, [element]);
      }
      $scope.investmentsRow = dict;
    }

    function init() {
      $rootScope.title = "";
      $scope.loading = true;
      loadMunicipalities()
      .then(() => loadAll())
      .catch(() => {
        $scope.loading = false;
      });
    }

    async function loadMunicipalities() {
      return MunicipalityRestService.get({
        filters: [`'status' EQ 'ENABLED'`],
        sorts: ['npp:ASC', 'name:ASC'],
    }).$promise.then((data) => $scope.municipalities = data._embedded)
    }

    function getRowLabels() {
      return Array.from($scope.investmentsRow.keys()).sort((a, b) => {
        if (a > b) {
          return 1;
        } else if (a < b) {
          return -1;
        }
        return 0;
      });
    }

    function loadAll() {
      $scope.loading = true;
      return new Promise((resolve, reject) => {
        InvestActivityService.api
          .getAll()
          .$promise
          .then((data) => {
            $scope.investments = data._embedded.map((el) => {
              return {
                name: el.municipality.name,
                id: el.id,
                value:
                  Number(((el.areaBudget || 0) +
                  (el.federalBudget || 0) +
                  (el.municipalityBudget || 0) +
                  (el.outbudget || 0)).toFixed(3)) +
                  " млн руб.",
              };
            });
            createMunicipalitiesDisctionary($scope.investments);
            $scope.sum = Number($scope.investments
              .map((el) => Number(el.value.replace(" млн руб.", "")))
              .reduce((acc, cur) => acc + cur, 0).toFixed(3));
            $scope.availableMunicipalities = $scope.municipalities.filter(n => !data._embedded.some(m => m.municipality.id === n.id))
            $scope.loading = false;
            resolve();
          })
          .catch(() => {
            $scope.loading = false
          });
      });
    }

    function changeViewType(type) {
      $scope.viewType = type;
    }

    function getStrokeColor(type) {
      return $scope.viewType === type ? "#3c8dbc" : "#333333";
    }

    function openDescription(id) {
      InvestActivityService.openDescription(id, $scope.availableMunicipalities).result
      .then(res => res === true && loadAll())
      .catch(res => res === true && loadAll());
    }
  },
];
